module.exports = __webpack_public_path__ + "img/budgetactions.620c3462.png";